var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 0.5L14.95 0.525L10.5 2.25L5.5 0.5L0.8 2.08333C0.625 2.14167 0.5 2.29167 0.5 2.48333V15.0833C0.5 15.3167 0.683333 15.5 0.916667 15.5L1.05 15.475L5.5 13.75L10.5 15.5L15.2 13.9167C15.375 13.8583 15.5 13.7083 15.5 13.5167V0.916667C15.5 0.683333 15.3167 0.5 15.0833 0.5ZM10.5 13.8333L5.5 12.075V2.16667L10.5 3.925V13.8333Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.df18cd6090f6372552d2488b5cdc5278.svg";
export { ForwardRef as ReactComponent };